import { Component, OnInit } from '@angular/core'

@Component({
    selector: 'DataEntryLayoutStep2',
    template: `
      <div class="row">
            <div class="col-20">
                <router-outlet></router-outlet>
            </div>
      </div>
  `
})

export class DataEntryLayoutEnrollmentStep2 implements OnInit {


    ngOnInit() {
    }

}
